import FacebookIcon from '@/public/assets/images/sign-in/facebook.png'
import DiscordIcon from '@/public/assets/images/sign-in/discord.png'
import GoogleIcon from '@/public/assets/images/sign-in/google.png'
import SteamIcon from '@/public/assets/images/sign-in/steam.png'
import TwitterIcon from '@/public/assets/images/sign-in/x.png'
import TelegramIcon from '@/public/assets/images/sign-in/telegram.png'
import { StaticImageData } from 'next/image'
import { OAuthOption } from 'node_modules/thirdweb/dist/types/wallets/types'

export const socialsMethods = [
  {
    icon: FacebookIcon,
    strategy: 'facebook',
  },
  {
    icon: DiscordIcon,
    strategy: 'discord',
  },
  {
    icon: GoogleIcon,
    strategy: 'google',
  },
  {
    icon: SteamIcon,
    strategy: 'steam',
  },
  {
    icon: TwitterIcon,
    strategy: 'x',
  },
  {
    icon: TelegramIcon,
    strategy: 'telegram',
  },
] as {
  icon: StaticImageData
  strategy: OAuthOption
}[]
